import { Component, Input } from '@angular/core';
import { Packet } from '../../models/packet';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: '[appointment-status]',
  templateUrl: './appointment-status.component.html',
  styleUrls: ['./appointment-status.component.scss'],
})

export class AppointmentStatus {

  /**
   * 각 패킷 상태에 따른 의미
   * @type {any}
   */
  private static PACKET_MEANING = [
    { status: Packet.STATUS.DONE, mean: '결제완료' },
    { status: Packet.STATUS.IN_PROGRESS, mean: '진행중' },
    { status: Packet.STATUS.PAUSED, mean: '정지' },
    { status: Packet.STATUS.TERMINATED, mean: '만료' },
    { status: Packet.STATUS.REPAID, mean: '환불' },
    { status: Packet.STATUS.NO_REG, mean: '미등록' },
  ];

  /**
   * 예외처리 된 패킷 상태의 의미
   * @type {string}
   */
  private static EXCEPTION_STATUS: string = '알수없음';

  /**
   * 패킷이 없는 경우 출력 할 날짜
   * @type {string}
   */
  private static NO_PACKET_DATE: string = '- - - -.  - -.  - -';

  /**
   * 센터연결 버튼의 링크 타입
   * @type {string}
   */
  private static LINK_PRE: string = 'tel:';

  /**
   * 시작 날짜
   * @type {string}
   */
  start: string = AppointmentStatus.NO_PACKET_DATE;

  /**
   * 종료 날짜
   * @type {string}
   */
  end: string = AppointmentStatus.NO_PACKET_DATE;

  /**
   * 상태
   * @type {string}
   */
  status: string = AppointmentStatus.EXCEPTION_STATUS;

  /**
   * 버튼 선택 링크
   * @type {string}
   */
  link: string = '';

  /**
   * 패킷 진행중 여부
   * @type {boolean}
   */
  isNotInProgress: boolean = true;

  constructor() {}

  @Input('packet') set packet(pkt: Packet) {
    if (pkt) {
      const fnDateFormat = (d: Date) => {
        let year: string;
        let month: string;
        let date: string;

        if (!d) {
          return AppointmentStatus.NO_PACKET_DATE;
        }

        year = '' + d.getFullYear();
        month = SharedService.addZero(d.getMonth() + 1);
        date = SharedService.addZero(d.getDate());

        return `${year}.${month}.${date}`;
      };
      this.start = fnDateFormat(pkt.start);
      this.end = fnDateFormat(pkt.end);
      this.status = this.getStatusMeaning(pkt.status);
      this.isNotInProgress = pkt.status !== Packet.STATUS.IN_PROGRESS;
    } else {
      this.start = AppointmentStatus.NO_PACKET_DATE;
      this.end = AppointmentStatus.NO_PACKET_DATE;
      this.status = this.getStatusMeaning(Packet.STATUS.NO_REG);
      this.isNotInProgress = true;
    }
  }

  @Input('link') set setLink(link: string) {
    if (link) {
      this.link = AppointmentStatus.LINK_PRE + link;
    } else {
      this.link = '';
    }
  }

  /**
   * 패킷 상태의 의미를 반환
   * @param {number} packetStatus 패킷 상태
   * @return {string} 상태 의미
   */
  private getStatusMeaning(packetStatus: number): string {
    const map = AppointmentStatus.PACKET_MEANING;
    let mean = AppointmentStatus.EXCEPTION_STATUS;

    mean = map.find((item) => {
      return item.status === packetStatus;
    }).mean;

    return mean;
  }
}
